"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logsReducer = (state, action) => {
    if (action.log && !action.log.timestamp) {
        action.log.timestamp = new Date();
    }
    switch (action.type) {
        case 'add':
            if (!action.log) {
                throw new Error('LogsTerminal: No log message found');
            }
            return [...state, action.log];
        case 'clear':
            return [];
        default:
            return state;
    }
};
//# sourceMappingURL=logsReducer.js.map